<template>
  <div class="headerCS">
    <!-- *****************app-bar**************** -->
    <v-app-bar app color="#EEEEEE" dark elevation="0" fixed :height="alto" flat>
      <v-container fluid>
        <v-row align="center">
          <v-col cols="4" class="header-first-column">
            <router-link to="/">
              <v-img
                alt="Commande Speciale Logo"
                class="shrink"
                :contain="true"
                src="@/assets/cslogo.svg"
                transition="scale-transition"
                height="60px"
                position="left"
              />
            </router-link>
          </v-col>
          <v-col cols="4">
            <ul class="px-0 mx-auto menu-views d-none d-md-flex">
              <li>
                <router-link to="/" class="menu-links">
                  <span>ARTLESS</span>
                  <div class="animation-line"></div>
                </router-link>
              </li>

              <li>
                <router-link to="/custom" class="menu-links">
                  <span>CUSTOM</span>
                  <div class="animation-line"></div>
                </router-link>
              </li>
              <li>
                <router-link to="/CS" class="menu-links bold" target="_blank">
                  <span>CS</span>
                  <div class="animation-line"></div>
                </router-link>
              </li>
              <li>
                <a href="https://www.collectiveselective.com/collections/artless" class="menu-links">
                  <span>Shop</span>
                  <div class="animation-line"></div>
                </a>
              </li>
              <li>
                <router-link to="/contact" class="menu-links">
                  <span>Contact</span>
                  <div class="animation-line"></div>
                </router-link>
              </li>
            </ul>
          </v-col>
          <v-col cols="4" class="text-right header-last-column">
            <template v-if="menu == 1">
              <div
                class="d-none d-md-inline-flex div-links-menu-custom"
                v-for="(link, lkh) in itemsMenu"
                v-bind:key="lkh"
              >
                <router-link
                  :to="link.url"
                  class="links-menu-custom not-text-decoration"
                >
                  <span class="links-menu-custom__span uppercase">{{
                    link.text
                  }}</span>
                </router-link>
              </div>
            </template>

            <div
              class="d-none d-md-inline-flex btn-search"
              @click="search = true"
            >
              <span class="menu-links" v-bind:class="{ 'active-btn': search }">
                Search
                <div class="animation-line"></div>
              </span>
            </div>

            <div class="breadcrumbs">
              <template v-for="(breadcrumb, br) in breadcrumbs">
                <router-link :to="breadcrumb.link" :key="'breadcrumb-'+br" v-if="breadcrumb.isLink"> {{breadcrumb.text}} </router-link> <span v-if="!breadcrumb.isLink" :key="'breadcrumb-text'+br">{{ breadcrumb.text }}</span> <span :key="'separator-'+br" v-if="br < breadcrumbs.length - 1"> / </span> 
              </template>
            </div>

            <v-img
              src="@/assets/img/icons/menu-mobile.svg"
              width="42"
              height="19"
              contain
              class="d-md-none ml-auto"
              @click="menuOpen = !menuOpen"
            ></v-img>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <!-- *****************/app-bar**************** -->

    

    <v-dialog
      v-model="search"
      scrollable
      fullscreen
    >
      <div id="search-container">

      
        <div style="position: absolute; top: 10px; right:10px;">
          <v-icon color="white" @click="search = false;">mdi-close</v-icon>
        </div>

        <v-container class="py-0">
          <v-row class="first-row">
            <v-col cols="12" sm="12">
              <v-text-field label="search" color="white" dark v-model="searchTerm"></v-text-field>

              <div class="inside-row">

                <v-row>
                  <v-col v-show="searchTerm.length > 1 && filteredProducts.length > 0">
                    <span class="d-block mx-auto white--text text-center bold">ARTLESS</span>
                    <template v-if="searchTerm != ''">
                      <template v-for="(product,p) in filteredProducts">
                        <v-row :key="'producto'+p" align="center" >
                          <v-col cols="auto">
                            <router-link :to="'/product/'+product.url">
                              <v-img
                                :src="'https://artlesscms.actstudio.xyz'+product.cover.path"
                                width="100"
                              ></v-img>
                            </router-link>
                          </v-col>
                          <v-col>
                            <router-link
                              :to="'/product/'+product.url"
                              style="color: white; text-decoration: none;text-transform: uppercase;"
                            >{{product.name}}</router-link>
                          </v-col>
                        </v-row>
                      </template>
                    </template>

                  </v-col>
                  <v-col v-show="searchTerm.length > 1 && filteredProductsCS.length > 0">
                    <span class="d-block mx-auto white--text text-center bold">CS</span>
                    <template v-if="searchTerm != ''">
                      <template v-for="(product,p) in filteredProductsCS">
                        <v-row :key="'producto'+p" align="center" >
                          <v-col cols="auto">
                            <router-link :to="'/CS/product/'+product.url">
                              <v-img
                                :src="'https://artlesscms.actstudio.xyz'+product.cover.path"
                                width="100"
                              ></v-img>
                            </router-link>
                          </v-col>
                          <v-col>
                            <router-link
                              :to="'/CS/product/'+product.url"
                              style="color: white; text-decoration: none;text-transform: uppercase;"
                            >{{product.name}}</router-link>
                          </v-col>
                        </v-row>
                      </template>
                    </template>
                  </v-col>
                  <v-col v-show="searchTerm.length > 1 && filteredCustomProducts.length > 0">
                    <span class="d-block mx-auto white--text text-center bold">CUSTOM</span>
                    <template v-if="searchTerm != ''">
                      <template v-for="(product,p) in filteredCustomProducts">
                        <v-row :key="'producto'+p" align="center" >
                          <v-col cols="auto">
                            <router-link :to="'/product/'+product.url">
                              <v-img
                                :src="'https://artlesscms.actstudio.xyz'+product.cover.path"
                                width="100"
                              ></v-img>
                            </router-link>
                          </v-col>
                          <v-col>
                            <router-link
                              :to="'/product/'+product.url"
                              style="color: white; text-decoration: none;text-transform: uppercase;"
                            >{{product.name}}</router-link>
                          </v-col>
                        </v-row>
                      </template>
                    </template>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-dialog>

    <v-dialog
      v-model="menuOpen"
      persistent
      fullscreen
      overlay-color="#221F1F"
    >
      <v-app-bar app fixed color="#221F1F" class="py-0 px-0" elevation="0">
        <v-container class="">
          <v-row>
            <v-col cols="4" class="px-0">
            </v-col>
            <v-col class=" px-0 text-right">
              <v-icon @click="menuOpen = false" color="white">mdi-close</v-icon>
            </v-col>
          </v-row>
        </v-container>
      </v-app-bar>
      <v-card color="#221F1F" dark elevation="0">
        
        <v-card-text style="padding-top: 56px;">
          
          <v-container>
            <v-row>
              <v-col cols="12">
                <router-link to="/">
                  <v-img
                    alt="Artless Logo"
                    class="shrink logo-artless-header"
                    contain
                    src="@/assets/img/icons/artless-logo-blanco.svg"
                    max-width="100%"
                  />
                </router-link>
              </v-col>
              <v-col cols="12">
                <v-expansion-panels class="expansion-menu-mobile">
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      Furniture
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="px-0">
                      <router-link to="/furniture" class="d-block white--text not-text-decoration category-link-mobile py-1">All</router-link>
                      <router-link to="/furniture/new" class="d-block white--text not-text-decoration category-link-mobile py-1">New</router-link>
                      <router-link color="#EEEEEE" v-for="(category, c) in categories" :key="'category-mobile-'+c" :to="'/furniture/'+category.url" class="d-block white--text not-text-decoration category-link-mobile py-1">
                        {{category.name}}
                      </router-link>
                      </v-list-item-title>
                    </v-list-item>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
              <v-col cols="6">
                <router-link to="/materials" class="menu-mobile-link">Materials</router-link>
              </v-col>
              <v-col cols="6">
                <router-link to="/contact" class="menu-mobile-link">Contact</router-link>
              </v-col>
              <v-col cols="6">
                <a href="https://www.collectiveselective.com/collections/artless" target="_blank" class="menu-mobile-link">Shop</a>
              </v-col>
              <v-col cols="6">
                <router-link to="/about" class="menu-mobile-link">About</router-link>
              </v-col>
            </v-row>

            <v-row class="mt-12">
              <v-col cols="12">
                <router-link to="/cs">
                  <v-img
                    alt="Custom Logo"
                    class="shrink"
                    :contain="true"
                    src="@/assets/img/cs-logo-1-blanco.svg"
                    height="95px"
                    position="left center"
                  >
                  </v-img>
                </router-link>
              </v-col>
              <v-col cols="12">
                <v-expansion-panels class="expansion-menu-mobile">
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      Furniture
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="px-0">
                      <router-link to="/furniture" class="d-block white--text not-text-decoration category-link-mobile py-1">All</router-link>
                      <router-link to="/furniture/new" class="d-block white--text not-text-decoration category-link-mobile py-1">New</router-link>
                      <router-link color="#EEEEEE" v-for="(category, c) in categories" :key="'category-mobile-'+c" :to="'/furniture/'+category.url" class="d-block white--text not-text-decoration category-link-mobile py-1">
                        {{category.name}}
                      </router-link>
                      </v-list-item-title>
                    </v-list-item>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>

            <v-row class="mt-12">
              <v-col>
                <router-link to="/custom">
                  <v-img
                    alt="Custom Logo"
                    class="shrink"
                    :contain="true"
                    src="@/assets/img/icons/custom-logo-white.svg"
                    height="25px"
                    position="left center"
                  >
                  </v-img>
                </router-link>
              </v-col>
              <v-col cols="12">
                <v-expansion-panels class="expansion-menu-mobile">
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      Furniture
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="px-0">
                      <router-link to="/furniture" class="d-block white--text not-text-decoration category-link-mobile py-1">All</router-link>
                      <router-link to="/furniture/new" class="d-block white--text not-text-decoration category-link-mobile py-1">New</router-link>
                      <router-link color="#EEEEEE" v-for="(category, c) in categories" :key="'category-mobile-'+c" :to="'/furniture/'+category.url" class="d-block white--text not-text-decoration category-link-mobile py-1">
                        {{category.name}}
                      </router-link>
                      </v-list-item-title>
                    </v-list-item>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
              <v-col cols="6">
                <router-link to="/custom/designers" class="menu-mobile-link">Designers</router-link>
              </v-col>
              <v-col cols="6">
                <router-link to="/custom/contact" class="menu-mobile-link">Contact</router-link>
              </v-col>
              <v-col cols="6">
                <router-link to="/custom/about" class="menu-mobile-link">About</router-link>
              </v-col>
            </v-row>

          </v-container>
          
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "Header",
  props: {
    menu: { type: Number, required: false },
    breadcrumbs: { type: Array, required: false }
  },
  data() {
    return {
      search: false,
      products: [],
      searchTerm: "",
      menuOpen: false,

      //if menu == 1 "custom"
      itemsMenu: [
        {
          url: "/",
          text: "home",
        },
        {
          url: "/custom/designers",
          text: "designers",
        },
        {
          url: "/CS",
          text: "CS",
        },
        {
          url: "/custom/about",
          text: "about",
        },
        {
          url: "/custom/contact",
          text: "contact",
        },
      ],
      categories: [],
    };
  },
  beforeMount: function () {
    fetch(
      "https://www.artlesscms.actstudio.xyz/api/collections/get/Products?token=a15be93e9cdb43ca2b3778c2077c26",
      {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          filter: {},
          populate: 1, // resolve linked collection items
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => (this.products = res.entries));

      fetch(
      "https://www.artlesscms.actstudio.xyz/api/collections/get/CSProduct?token=a15be93e9cdb43ca2b3778c2077c26",
      {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          filter: {},
          populate: 1, // resolve linked collection items
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => (this.CSproducts = res.entries));

      fetch(
      "https://www.artlesscms.actstudio.xyz/api/collections/get/CustomProduct?token=a15be93e9cdb43ca2b3778c2077c26",
      {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          filter: {},
          populate: 1, // resolve linked collection items
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => (this.CustomProducts = res.entries));

    var aux = this;
    fetch(
      "https://www.artlesscms.actstudio.xyz/api/collections/get/Categories?token=a15be93e9cdb43ca2b3778c2077c26",
      {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          populate: 1, // resolve linked collection items
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => (aux.categories = res.entries));
  },
  mounted: function () {
    console.log(this.$vuetify);
  },
  computed: {
    urlName: function () {
      return this.$route.name;
    },
    filteredProducts: function () {
      var productos = this.products;
      var aux = this;
      // alert(this.searchTerm)

      return productos.filter(function (term) {
        if (term.name.toUpperCase().includes(aux.searchTerm.toUpperCase())) {
          return true;
        }
      });
    },
    filteredProductsCS: function(){
      var products = this.CSproducts;

      var aux = this;

      return products.filter(function(term){
        if(term.name.toUpperCase().includes(aux.searchTerm.toUpperCase())){
          return true
        }
      });
    },
    filteredCustomProducts: function () {
      var productos = this.CustomProducts;
      var aux = this;
      // alert(this.searchTerm)

      return productos.filter(function (term) {
        if (term.name.toUpperCase().includes(aux.searchTerm.toUpperCase())) {
          return true;
        }
      });
    },
    align: function () {
      if (this.searchTerm.length == 0) {
        return "center";
      } else {
        return "top";
      }
    },
    alto: function () {
      if (this.$vuetify.breakpoint.width >= 2300) {
        if (this.$vuetify.breakpoint.width >= 3500) {
          return 180;
        } else {
          return 130;
        }
      } else {
        return 100;
      }
    },
  },
  watch: {
    $route(to, from) {
      this.search = false;
      this.menuOpen = false;
    },
    search() {
      if (this.search) {
        document.body.classList.add("block-scroll");
      } else {
        document.body.classList.remove("block-scroll");
      }
    },
  },
};
</script>
